import { ChevronLeft24Filled } from '@fluentui/react-icons';
import {
  ExpertTopContainer,
  ClearAllButton,
} from '../style/SkillsWidget.style';
import { AddSkillsBackButtonContainer } from '../../common/styles/common.styled';
import { TeamsFxContext } from 'src/context/TeamsContext';
import { useContext } from 'react';

interface ExpertContainerMobileProps {
  setFindExpertPopup: React.Dispatch<React.SetStateAction<boolean>>;
  onClear: () => void;
  isClearAllVisible: string | true;
}

export const ExpertContainerMobile = ({
  isClearAllVisible,
  onClear,
  setFindExpertPopup,
}: ExpertContainerMobileProps) => {
  const { isMobile } = useContext(TeamsFxContext);
  return (
    <ExpertTopContainer>
      <AddSkillsBackButtonContainer
        onClick={() => {
          setFindExpertPopup(false);
          onClear();
        }}
      >
        <ChevronLeft24Filled />
      </AddSkillsBackButtonContainer>
      <h1>Find an expert</h1>
      <ClearAllButton
        isClearAllVisible={isClearAllVisible}
        isMobile={isMobile}
        onClick={onClear}
      >
        Clear all
      </ClearAllButton>
    </ExpertTopContainer>
  );
};
